<div class="input-wrapper fx fx-row fx-gap-1em fx-align-start">
  <mat-checkbox [checked]="paginationEnabled" (change)="paginationEnabled = !paginationEnabled"> Show Pagination </mat-checkbox>
  <mat-checkbox [checked]="filterEnabled" (change)="filterEnabled = !filterEnabled"> Show Filter </mat-checkbox>
</div>

<mad-data-table
  [displayedColumns]="displayedColumns"
  [tableData]="tableData"
  [defaultPageSize]="10"
  [paginationEnabled]="paginationEnabled"
  [filterEnabled]="filterEnabled"
>
</mad-data-table>
